import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

// Lazy store resolution: a module-scope import here closes a cycle
// (stores -> components -> mixins -> classes). See scripts/find-import-cycles.py.
// eslint-disable-next-line global-require
const useDynamicComponentEditorStore = (...args) => require("%/dynamic-component-editor/stores/dynamic-component-editor").default(...args);


export default class Effects extends BaseOption {
  static defaultAnimationOptions = [
    {
      name: "Fade In",
      id: "fade-in",
    },
    {
      name: "Slide In From Left",
      id: "slide-in-from-left",
    },
    {
      name: "Slide In From Right",
      id: "slide-in-from-right",
    },
    {
      name: "Bounce In",
      id: "bounce-in",
    },
    {
      name: "Pulse",
      id: "pulse",
    },
    {
      name: "Slide Down",
      id: "slide-down",
    },
    {
      name: "Slide Up",
      id: "slide-up",
    },
    {
      name: "Scale In",
      id: "scale-in",
    },
    {
      name: "Image Blur In",
      id: "image-blur-in",
    },
    {
      name: "Mask Reveal",
      id: "mask-reveal",
    },
  ];

  static hoverAnimationOptions = [
    {
      name: "Soft Scale",
      id: "soft-scale",
    },
    {
      name: "Micro Lift",
      id: "micro-lift",
    },
    {
      name: "Micro Compress",
      id: "micro-compress",
    },
    {
      name: "Lift Scale",
      id: "lift-scale",
    },
  ];

  static userInterfaceComponent = () => {
    return {
      label: "Animations",
      component: inspectorTools.SIMPLE_PICKER,
      canSetOtherStates: [BaseOption.$states.HOVER],
      ignoreDefaultIfNotSetForState: [BaseOption.$states.HOVER],
      props: {
        options: this.getAnimationOptionsForState(),
      },
    };
  };

  static getAnimationOptionsForState() {
    const currentOptionState = useDynamicComponentEditorStore().optionState;
    const isHoverState = currentOptionState === BaseOption.$states.HOVER;

    if (isHoverState) {
      return this.hoverAnimationOptions;
    }

    return this.defaultAnimationOptions;
  }

  static defaultValue = "none";
}
